import { ActionTypes } from './actionTypes';
import type {
  ClearImportGeofences,
  DeleteGeofenceRequest,
  DeleteGeofenceSucceeded,
  EditGeofenceRequest,
  ImportGeofencesFailed,
  ImportGeofencesRequest,
  ImportGeofencesSucceeded,
  LoadGeofencesFailed,
  LoadGeofencesRequest,
  LoadGeofencesSucceeded,
  SaveGeofenceRequest,
  SaveGeofenceSucceeded,
  ValidateGeofencesFailed,
  ValidateGeofencesRequest,
  ValidateGeofencesSucceeded,
} from './actions';

import type { Geofence, GeofenceValidationQuery, GeofenceValidationSummary, UUID } from '@cobliteam/common-types';

export const deleteGeofenceRequest = (geofence: Geofence, fleetId: UUID): DeleteGeofenceRequest => ({
  type: ActionTypes.DELETE_GEOFENCE_REQUEST,
  payload: {
    geofence,
    fleetId,
  },
});

export const deleteGeofenceSucceeded = (geofenceId: UUID): DeleteGeofenceSucceeded => ({
  type: ActionTypes.DELETE_GEOFENCE_SUCCEEDED,
  payload: geofenceId,
});

export const editGeofenceRequest = (geofence: Geofence, fleetId: UUID): EditGeofenceRequest => ({
  type: ActionTypes.EDIT_GEOFENCE_REQUEST,
  payload: {
    geofence,
    fleetId,
  },
});

export const saveGeofenceRequest = (geofence: Geofence): SaveGeofenceRequest => ({
  type: ActionTypes.SAVE_GEOFENCE_REQUEST,
  payload: geofence,
});

export const saveGeofenceSucceeded = (newGeofence: Geofence): SaveGeofenceSucceeded => ({
  type: ActionTypes.SAVE_GEOFENCE_SUCCEEDED,
  payload: newGeofence,
});

export const loadGeofencesRequest = (): LoadGeofencesRequest => ({
  type: ActionTypes.LOAD_GEOFENCES_REQUEST,
});

export const loadGeofencesSucceeded = (geofences: Geofence[]): LoadGeofencesSucceeded => ({
  type: ActionTypes.LOAD_GEOFENCES_SUCCEEDED,
  payload: geofences,
});

export const loadGeofencesFailed = (): LoadGeofencesFailed => ({
  type: ActionTypes.LOAD_GEOFENCES_FAILED,
});

// GEOFENCE BATCH VALIDATION
export const validateGeofencesRequest = (query: GeofenceValidationQuery[]): ValidateGeofencesRequest => ({
  type: ActionTypes.VALIDATE_GEOFENCES_REQUEST,
  payload: query,
});

export const validateGeofencesSucceeded = (summary: GeofenceValidationSummary): ValidateGeofencesSucceeded => ({
  type: ActionTypes.VALIDATE_GEOFENCES_SUCCEEDED,
  payload: summary,
});

export const validateGeofencesFailed = (): ValidateGeofencesFailed => ({
  type: ActionTypes.VALIDATE_GEOFENCES_FAILED,
});

// GEOFENCE BATCH IMPORT
export const importGeofencesRequest = (importId: UUID): ImportGeofencesRequest => ({
  type: ActionTypes.IMPORT_GEOFENCES_REQUEST,
  payload: importId,
});

export const importGeofencesSucceeded = (): ImportGeofencesSucceeded => ({
  type: ActionTypes.IMPORT_GEOFENCES_SUCCEEDED,
});

export const importGeofencesFailed = (): ImportGeofencesFailed => ({
  type: ActionTypes.IMPORT_GEOFENCES_FAILED,
});

// GEOFENCE BATCH CLEAR
export const clearImportGeofences = (): ClearImportGeofences => ({
  type: ActionTypes.CLEAR_IMPORT_GEOFENCES,
});
